import { Component } from '@angular/core';

@Component({
  selector: 'ds-rg-forgot-password',
  templateUrl: './rg-forgot-password.component.html',
  styleUrl: './rg-forgot-password.component.scss'
})
export class RgForgotPasswordComponent {
  currentDate = new Date();
  currentYear = this.currentDate.getFullYear();
}
